var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "otherSources"
  }, [_c('div', {
    staticClass: "pageTitle"
  }, [_vm._v("其他監控來源")]), _c('b-tabs', {
    staticClass: "mx-2",
    attrs: {
      "active-nav-item-class": "font-weight-bold",
      "lazy": ""
    },
    model: {
      value: _vm.tabIndex,
      callback: function callback($$v) {
        _vm.tabIndex = $$v;
      },
      expression: "tabIndex"
    }
  }, _vm._l(_vm.sources, function (s) {
    return _c('b-tab', {
      key: s.key,
      attrs: {
        "disabled": !s.ready
      },
      scopedSlots: _vm._u([{
        key: "title",
        fn: function fn() {
          return [_c('i', {
            staticClass: "mr-1",
            class: s.icon
          }), _vm._v(_vm._s(s.label) + " "), !s.ready ? _c('b-badge', {
            staticClass: "ml-1",
            attrs: {
              "variant": "light"
            }
          }, [_vm._v("未接")]) : _vm._e()];
        },
        proxy: true
      }], null, true)
    }, [s.ready ? _c(s.component, {
      tag: "component"
    }) : _vm._e()], 1);
  }), 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };